export default __webpack_public_path__ + "static/media/long-arrow-icon.de4e86b8.svg";